import { HeatMapChart } from '@/components/composite/Charts/HeatMapChart';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { percentFormat } from '@/hooks/format/useFormatNumber';

export const bestTimeToPostConfig = {
    minWidth: 750,
    name: {
        day: {
            engagement_rate: 'chart.best_time_to_post.engagement_more',
            reach: 'chart.best_time_to_post.reach_more'
        },
        value: {
            engagement_rate: 'chart.best_time_to_post.engagement_less',
            reach: 'chart.best_time_to_post.reach_less'
        }
    },
    noTableView: true,
    csv: true,
    id: 'best_time_to_post',
    color: {
        value: 'white'
    },
    colors: {
        light: {
            blue200: '#96D8FF',
            blue300: '#33a1ff',
            blue400: '#1a95ff',
            blue: '#0089ff'
        },
        dark: {
            blue200: '#11263F',
            blue300: '#0E3861',
            blue400: '#085BA5',
            blue: '#0089ff'
        }
    },
    legendType: 'bttp',
    tooltipTranslation: {
        filtersToken: {
            engagement_rate: 'chart.linkedin.best_time_to_post_engagement_tooltip_chart',
            reach: 'chart.linkedin.best_time_to_post_reach_tooltip_chart'
        },
        values: ['date', 'day', 'value', 'count_posts']
    },
    valueFormat: {
        engagement_rate: { ...percentFormat, maximumFractionDigits: 5 },
        reach: {}
    },
    legendHighlightValueTranslation: {
        filtersToken: {
            engagement_rate: 'chart.linkedin.best_time_to_post_engagement_legend_highlight',
            reach: 'chart.linkedin.best_time_to_post_reach_legend_highlight'
        },
        values: ['date', 'day']
    },
    defaultFilter: 'engagement_rate',
    filters: {
        engagement_rate: {
            title: 'chart.linkedin.best_time_to_post_engagement',
            menu: 'chart.linkedin.best_time_to_post_filter_engagement'
        },
        reach: {
            title: 'chart.linkedin.best_time_to_post_reach',
            menu: 'chart.linkedin.best_time_to_post_filter_reach'
        }
    },
    noDataToken: 'chart.linkedin.no_data_history_period',
    tooltip: 'chart.linkedin.tooltip_best_time_to_post_engagement',
    size: SIZE_FULL,
    type: 'chart',
    iconHighestValue: 'star',
    margin: { bottom: 10, left: -30 },
    breakpoints: [
        { color: 'blue200', r: 3.5 },
        { color: 'blue300', r: 7.5 },
        { color: 'blue400', r: 12.5 },
        { color: 'blue', r: 12.5 }
    ],
    element: HeatMapChart
};
